import React, { useEffect, useRef, useState } from 'react'
import { Link,useNavigate,useParams} from 'react-router-dom'
// import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import Slider from 'react-slick'
// import $ from 'jquery'
import { useCart } from '../../CartContext';
import ProductTabs from '../ProductTabs';
import { supabase } from '../../lib/supabaseClient.ts';




export default function ShopDetailsArea() {
  const [showModal, setShowModal] = useState(false);
const [relatedProductsType, setRelatedProductsType] = useState(""); // "subcategory" or "category"

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const settingss = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const [relatedProducts, setRelatedProducts] = useState([]);
    const { id } = useParams();
    const { addToCart } = useCart();

    // States
    const [product, setProduct] = useState(null);
    const [variations, setVariations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const selectedProduct = product;
const [filterPoids, setFilterPoids] = useState(""); // e.g., "3kg"

    // Selection states
    const [selectedGout, setSelectedGout] = useState("");
    const [selectedPoids, setSelectedPoids] = useState("");
    const [val, setVal] = useState(1);
const navigate = useNavigate();

    const isMountedRef = useRef(true);
const [isMobile, setIsMobile] = useState(false);
useEffect(() => {
  const fetchVariations = async () => {
    const { data } = await supabase
      .from("product_variations")
      .select("*")
      .eq("product_id", product.id);

    setVariations(data || []);
  };

  if (product?.id) {
    fetchVariations();
  }
}, [product?.id]);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  handleResize(); // initial check
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);
useEffect(() => {
    console.log("Updated product:", product);
}, [product]);


useEffect(() => {
  const fetchProductData = async () => {
    if (!id) return;

    setLoading(true);
    setError(null);

    try {
      // Fetch product
      const { data: productData, error: productError } = await supabase
        .from("products")
        .select("*")
        .eq("id", id)
        .maybeSingle();
      if (productError) throw productError;
      if (!productData) throw new Error("Product not found");

      // Log the product data to verify promo and promo_percentage fields
      console.log('Product Data:', productData); // Debugging log

      // Fetch variations
      const { data: variationsData, error: variationsError } = await supabase
    .from("product_variations")
    .select("variation_name, weight, price, old_price, image, composition, analysis, ingredients, antioxidants, energy, available, promo, promo_percentage, promo_type")
    .eq("product_id", id);

      if (variationsError) throw variationsError;
      if (!isMountedRef.current) return;

      // Log the variations data to check the promo fields
      console.log('Variations Data:', variationsData); // Debugging log

      // ✅ If there are variations
      if (variationsData && variationsData.length > 0) {
        const structuredVariations = {};

 variationsData.forEach((variation) => {
  const {
    variation_name: gout,
    weight: poids,
    price,
    old_price: oldPrice,
    image,
    composition,        // ✅ NEW
    analysis,          // ✅ NEW
    ingredients,       // ✅ NEW
    energy,            // ✅ NEW    
    // composition: description,
    // analysis: avantages,
    // ingredients: dose,
    // energy: guide,
    antioxidants,
    available,
    promo,
    promo_percentage
  } = variation;

  // ✅ FIXED: Clean and parse price properly
  const cleanPriceString = (priceStr) => {
    if (!priceStr) return "0";
    
    let cleaned = String(priceStr)
      .replace(/[^\d.,-]/g, "")
      .trim();
    
    if (cleaned.includes(".") && cleaned.includes(",")) {
      cleaned = cleaned.replace(/\./g, "").replace(",", ".");
    } else if (cleaned.includes(",")) {
      const parts = cleaned.split(",");
      if (parts[1]?.length === 3) {
        cleaned = cleaned.replace(",", "");
      } else {
        cleaned = cleaned.replace(",", ".");
      }
    }
    
    return cleaned;
  };

  const basePrice = parseFloat(cleanPriceString(price)) || 0;
  const oldPriceNum = oldPrice ? parseFloat(cleanPriceString(oldPrice)) : null;

  // ✅ FIX: Don't apply discount here - store original prices
  // The discount will be applied during display only
  const finalPrice = basePrice.toFixed(3);
  const finalOldPrice = oldPriceNum ? oldPriceNum.toFixed(3) : null;

  if (!structuredVariations[gout]) {
    structuredVariations[gout] = {
      weights: [],
      details: {},
    };
  }

  const trimmedPoids = poids.trim();

  if (!structuredVariations[gout].weights.includes(trimmedPoids)) {
    structuredVariations[gout].weights.push(trimmedPoids);
  }

structuredVariations[gout].details[trimmedPoids] = {
    price: finalPrice,
    oldPrice: finalOldPrice,
    image,
    // description,
    // avantages,
    // dose,
    // guide,
    composition,        // ✅ NEW
    analysis,          // ✅ NEW
    ingredients,       // ✅ NEW
    antioxidants,      // ✅ NEW
    energy,            // ✅ NEW    available: !!available,
    promo: !!promo,
    promo_percentage: promo_percentage || 0,
    promo_type: variation.promo_type || 'percentage'  // ✅ ADD THIS LINE
};
});
        // ✅ Set product with structured variations
        setProduct({ ...productData, variations: structuredVariations });

        // ✅ Safe default selection
        const goutKeys = Object.keys(structuredVariations);
        if (goutKeys.length > 0) {
          const firstGout = goutKeys[0];
          const firstPoids = structuredVariations[firstGout]?.weights?.[0] || "";
          setSelectedGout(firstGout);
          setSelectedPoids(firstPoids);
        } else {
          setSelectedGout("");
          setSelectedPoids("");
        }

      } else {
  // ✅ No variations: set product directly
  
  // ✅ FIX: Use price_range if price doesn't exist
  const basePrice = productData.price || productData.price_range;
  
  if (!basePrice) {
    console.error("Missing price for product:", productData);
    setProduct({
      ...productData,
      variations: null,
      selectedPrice: "0.00",
      selectedOldPrice: productData.old_price,
      image: productData.image,
      description: productData.description,
        composition: productData.composition,      // ✅ NEW
  analysis: productData.analysis,            // ✅ NEW
  ingredients: productData.ingredients,      // ✅ NEW
  antioxidants: productData.antioxidants,    // ✅ NEW
  energy: productData.energy,                // ✅ NEW
      avantages: productData.avantages,
      dose: productData.dose,
      guide: productData.ingredients,
      available: productData.available ?? true,
    });
    setSelectedGout("");
    setSelectedPoids("");
    return;
  }

  // ✅ Clean the price string properly
  const cleanPrice = String(basePrice)
    .replace(/[^\d.,-]/g, "") // Remove non-numeric chars except . , -
    .replace(/\./g, "")        // Remove thousand separators
    .replace(",", ".");         // Convert comma to dot for decimals

  const basePriceNum = parseFloat(cleanPrice);

  if (isNaN(basePriceNum)) {
    console.error("Invalid price format:", basePrice, "cleaned:", cleanPrice);
    setProduct({
      ...productData,
      variations: null,
      selectedPrice: "0.00",
      image: productData.image,
      description: productData.description,
      available: productData.available ?? true,
    });
    setSelectedGout("");
    setSelectedPoids("");
    return;
  }

  // ✅ Apply promo if exists
  const finalPrice = productData.promo && productData.promo_percentage
    ? (basePriceNum * (1 - productData.promo_percentage / 100)).toFixed(2)
    : basePriceNum.toFixed(2);

  const finalOldPrice = productData.old_price && productData.promo && productData.promo_percentage
    ? (parseFloat(String(productData.old_price).replace(/[^\d.,-]/g, "").replace(",", ".")) * 
       (1 - productData.promo_percentage / 100)).toFixed(2)
    : productData.old_price;

  setProduct({
    ...productData,
    variations: null,
    selectedPrice: basePriceNum.toFixed(3),  // ✅ Store original price
    selectedOldPrice: finalOldPrice,
    image: productData.image,
    description: productData.description,
    avantages: productData.avantages,
    dose: productData.dose,
    guide: productData.ingredients,
    antioxidants: productData.antioxidants,
    available: productData.available ?? true,
    promo: productData.promo,  // ✅ Just store the flag
    promo_percentage: productData.promo_percentage  // ✅ Just store the percentage
  });

  setSelectedGout("");
  setSelectedPoids("");
}

      // ✅ Fetch related products
  if (productData?.subcategory || productData?.category) {
  let similarProducts = [];

  // Parse subcategory (it might be a JSON string array)
  let productSubcategories = [];
  try {
    productSubcategories = typeof productData.subcategory === 'string' 
      ? JSON.parse(productData.subcategory) 
      : Array.isArray(productData.subcategory) 
        ? productData.subcategory 
        : productData.subcategory ? [productData.subcategory] : [];
  } catch {
    productSubcategories = productData.subcategory ? [productData.subcategory] : [];
  }

  // Try to find products with matching subcategory first
  if (productSubcategories.length > 0) {
    const { data: subcategoryProducts, error: subError } = await supabase
      .from("products")
      .select("*")
      .neq("id", productData.id);

    if (!subError && subcategoryProducts) {
      // Filter products that share at least one subcategory
      similarProducts = subcategoryProducts.filter(product => {
        let productSubs = [];
        try {
          productSubs = typeof product.subcategory === 'string' 
            ? JSON.parse(product.subcategory) 
            : Array.isArray(product.subcategory) 
              ? product.subcategory 
              : product.subcategory ? [product.subcategory] : [];
        } catch {
          productSubs = product.subcategory ? [product.subcategory] : [];
        }

        // Check if any subcategory matches
        return productSubs.some(sub => 
          productSubcategories.some(currentSub => 
            sub?.trim().toLowerCase() === currentSub?.trim().toLowerCase()
          )
        );
      });
    }
  }

  // If no subcategory matches found, fallback to category matching
  if (similarProducts.length === 0 && productData.category) {
    // Parse category (might also be JSON array)
    let productCategories = [];
    try {
      productCategories = typeof productData.category === 'string' 
        ? JSON.parse(productData.category) 
        : Array.isArray(productData.category) 
          ? productData.category 
          : [productData.category];
    } catch {
      productCategories = productData.category ? [productData.category] : [];
    }

    const { data: categoryProducts, error: catError } = await supabase
      .from("products")
      .select("*")
      .neq("id", productData.id);

    if (!catError && categoryProducts) {
      // Filter products that share at least one category
      similarProducts = categoryProducts.filter(product => {
        let productCats = [];
        try {
          productCats = typeof product.category === 'string' 
            ? JSON.parse(product.category) 
            : Array.isArray(product.category) 
              ? product.category 
              : [product.category];
        } catch {
          productCats = product.category ? [product.category] : [];
        }

        // Check if any category matches
        return productCats.some(cat => 
          productCategories.some(currentCat => 
            cat?.trim().toLowerCase() === currentCat?.trim().toLowerCase()
          )
        );
      });
    }
  }

  // Limit to 5 products and set state
  setRelatedProducts(similarProducts.slice(0, 5) || []);
}

    } catch (err) {
      console.error("Error fetching product:", err);
      if (isMountedRef.current) setError(err.message);
    } finally {
      if (isMountedRef.current) setLoading(false);
    }
  };

  fetchProductData();
}, [id]);


    // Parse price string
    const parsePriceStr = (priceStr) => {
        if (!priceStr) return 0;
        const cleaned = priceStr
            .replace(/[^\d,.-]/g, '')
            .replace(/\./g, '')
            .replace(',', '.');
        const priceNum = parseFloat(cleaned);
        return isNaN(priceNum) ? 0 : priceNum;
    };

const handleAddToCart = () => { 
  if (!product) return;

  let variationData;
  let selectedPriceStr;
  let promoPercentage = 0;
  let hasPromo = false;

  if (hasVariations) {
    if (!selectedGout || !selectedPoids) return;

    variationData = product.variations?.[selectedGout]?.details?.[selectedPoids];
    if (!variationData) return;

    // ✅ Use oldPrice if promo exists, otherwise use price
    if (variationData.promo && variationData.oldPrice) {
      selectedPriceStr = variationData.oldPrice.toString();
    } else if (variationData.price) {
      selectedPriceStr = variationData.price.toString();
    } else {
      console.error("Missing price for variation:", variationData);
      return;
    }

    // ✅ Get promo info from variation
    hasPromo = variationData.promo || false;
    promoPercentage = variationData.promo_percentage || 0;

  } else {
    variationData = {
      price: product.selectedPrice || product.price_range,
      image: product.image,
      description: product.description,
          composition: product.composition,        // ✅ NEW
    analysis: product.analysis,              // ✅ NEW
    ingredients: product.ingredients,        // ✅ NEW
    antioxidants: product.antioxidants,      // ✅ NEW
    energy: product.energy,                  // ✅ NEW
      available: product.available ?? true,
    };

    selectedPriceStr = product.selectedPrice?.toString() || product.price_range?.toString() || null;

    if (!selectedPriceStr) {
      console.error("Missing product base price:", product);
      return;
    }

    // ✅ Get promo info from product
    hasPromo = product.promo || false;
    promoPercentage = product.promo_percentage || 0;
  }

  // Clean price string
  let cleanPrice = String(selectedPriceStr)
    .replace(/[^\d.,-]/g, "")
    .trim();

  if (cleanPrice.includes(".") && cleanPrice.includes(",")) {
    cleanPrice = cleanPrice.replace(/\./g, "").replace(",", ".");
  } else if (cleanPrice.includes(",")) {
    const parts = cleanPrice.split(",");
    if (parts[1]?.length === 3) {
      cleanPrice = cleanPrice.replace(",", "");
    } else {
      cleanPrice = cleanPrice.replace(",", ".");
    }
  }

  const basePrice = parseFloat(cleanPrice);

  if (isNaN(basePrice)) {
    console.error("Invalid price string:", selectedPriceStr, "cleaned:", cleanPrice);
    return;
  }

  // ✅ Apply discount only if promo exists
  let finalPriceNum;
  if (hasPromo && promoPercentage > 0) {
    finalPriceNum = basePrice * (1 - promoPercentage / 100);
  } else {
    finalPriceNum = basePrice;
  }

  const selectedVariation = {
    id: product.id,
    name: product.name,
    brand: product.brand,
    category: product.category,
    subcategory: product.subcategory,
    best: product.best,
    new: product.new,
    promo: hasPromo,
    promo_percentage: promoPercentage,
    stock_status: product.stock_status,
    selectedGout: hasVariations ? selectedGout : null,
    selectedWeight: hasVariations ? selectedPoids : null,
    selectedPrice: finalPriceNum.toString(),
    priceDisplay: `${finalPriceNum.toLocaleString("fr-FR", {
      style: "decimal",
      minimumFractionDigits: 3, 
      maximumFractionDigits: 10
    })} DT`,
    image: variationData?.image || product.image,
    available: variationData?.available ?? true,
    description: variationData?.description || product.description,
    quantity: val,
    chosenVariation: hasVariations
      ? {
          gout: selectedGout,
          poids: selectedPoids,
          ...variationData,
        }
      : null,
  };

  console.log("✅ Adding to cart:", selectedVariation);
  addToCart(selectedVariation);
  setShowModal(true);

};
   const handleContinueShopping = () => {
    setShowModal(false);
};

const handleGoToCheckout = () => {
    setShowModal(false);
    navigate('/checkout'); // Adjust path if needed
};
const increase = () => setVal(val + 1);
    const decrease = () => val > 1 && setVal(val - 1);

    // Loading state
    if (loading) {
        return (
            <div className="container pt-100 text-center">
                <div>Chargement du produit...</div>
            </div>
        );
    }

    // Error state
    if (error) {
        return (
            <div className="container pt-100 text-center">
                <div>Erreur: {error}</div>
            </div>
        );
    }

    // Product not found
    if (!product) {
        return (
            <div className="container pt-100 text-center">
                Produit non trouvé
            </div>
        );
    }

    // Check if product has variations
    const hasVariations = product.variations && Object.keys(product.variations).length > 0;

    // Get selected product details
// Get selected product details
// Get selected product details
const selectedProductDetails = hasVariations
  ? variations.find(
      (v) =>
        v.variation_name?.trim().toLowerCase() === selectedGout?.trim().toLowerCase() &&
        v.weight?.trim().toLowerCase() === selectedPoids?.trim().toLowerCase()
    )
  : {
      price: product.selectedPrice || product.price_range || 0,
      old_price: product.old_price || product.price_range || 0,
      image: product.image,
      description: product.description,
      composition: product.composition,
      analysis: product.analysis,
      ingredients: product.ingredients,
      antioxidants: product.antioxidants,
      energy: product.energy,
      available: true,
      promo: product.promo,
      promo_percentage: product.promo_percentage
    };

// Format price with thousands separator and no decimals
const formatPrice = (price) => {
    if (price == null) return "0"; // handle null/undefined
    return new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(price); // Format the price without decimals
};

// Get display price
const displayPrice = selectedProductDetails?.price || "N/A";
const originalPrice = parseFloat(displayPrice) || 0;  // Parse price to a number
const discount = selectedProductDetails?.promo_percentage || 0;
const discountedPrice = originalPrice * (1 - discount / 100);  // Calculate discounted price

// Format prices properly
const formattedOriginalPrice = formatPrice(originalPrice);
const formattedDiscountedPrice = formatPrice(discountedPrice);

    return (
        <section className="shop-details-area pt-110 pb-50">
            <div className="container">
                <div className="shop-details-wrap">
                    <div className="row">
                        <div className="col-7">
                            <div className="shop-details-img-wrap">
                                <div className="tab-content">
                                    <div className="tab-pane show active">
                                        <div className="shop-details-img">
                                          <img
  src={selectedProductDetails?.image || product.image}
  alt={product.name}
  className="zoomable-image"
  style={{
    width: '70%',
    height: '420px',
    objectFit: 'cover',
    borderRadius: '6px',
    marginBottom: '1rem',
    marginTop: "120px",
    marginLeft: isMobile ? "150px" : "50px", // same margin for desktop, 50px on mobile
    transition: 'transform 0.3s ease',
    cursor: 'zoom-in'
  }}
/>

{/* Stock badge */}
<div
  style={{
    position: "absolute",
    top: "10px",
    left: "10px",
    padding: "6px 12px",
    borderRadius: "8px",
    backgroundColor:
      product?.stock_status?.trim().toLowerCase() === "en stock"
        ? "rgba(16, 141, 45, 0.59)"
        : "rgba(220, 53, 69, 0.8)",
    color: "#fff",
    fontWeight: "600",
    fontSize: "0.9rem",
    zIndex: 10,
  }}
>
  {product?.stock_status?.trim().toLowerCase() === "en stock"
    ? "En stock"
    : "Rupture de stock"}
</div>



                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-5">
                            <div className="shop-details-content">
<span>
  {(() => {
    const parseField = (field) => {
      if (!field) return null;

      try {
        const parsed = JSON.parse(field);
        return Array.isArray(parsed) ? parsed.join(", ") : parsed;
      } catch (e) {
        return field;
      }
    };

    const category = parseField(product.category);
    const subcategory = parseField(product.subcategory);

    if (category && subcategory) {
      return `${category} - ${subcategory}`;
    }

    return category || subcategory || "Catégorie";
  })()}
</span>
                  
           <h2 className="title">{product.name} 
{!hasVariations && product.weight && (
  <div
    style={{
      backgroundColor: "#e8f5e9", // light green background
      color: "#2e7d32",
      padding: "0.75rem 1rem",
      borderRadius: "8px",
      marginTop: "1rem",
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      fontWeight: "600",
      fontSize: "0.95rem",
      boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
    }}
  >
    {/* <span style={{ fontSize: "1.1rem" }}>⚖️</span> */}
    <span> {product.weight}</span>
  </div>
)}</h2>

<div
  className="shop-details-price-badge"
  style={{
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    padding: "6px 12px",
    borderRadius: "20px",
    backgroundColor: "#c71585",
    color: "#ffffff",
    fontWeight: "600",
    fontSize: "16px",
    userSelect: "none",
  }}
>
<div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "flex-start" : "center",
    gap: "6px",
  }}
>
  {/* Promo Badge */}
  {selectedProductDetails?.promo && (
    <div
      className="badge mb-1 text-white fw-bold"
      style={{
        backgroundColor:
          selectedProductDetails.promo_type === "percentage" ? "#28a745" : "#ff41b4",
        fontSize: isMobile ? "0.65rem" : "0.75rem",
        padding: isMobile ? "0.2rem 0.4rem" : "0.25rem 0.6rem",
        borderRadius: "0.5rem",
        display: "inline-block",
        marginBottom: isMobile ? "0.2rem" : "0.3rem",
      }}
    >
      {(() => {
        if (
          selectedProductDetails.promo_type === "percentage" &&
          selectedProductDetails.promo_percentage
        ) {
          return `${selectedProductDetails.promo_percentage}% de réduction`;
        }

        if (
          selectedProductDetails.promo_type === "exact" &&
          selectedProductDetails.oldPrice &&
          selectedProductDetails.price
        ) {
          const oldPrice = parseFloat(selectedProductDetails.oldPrice);
          const newPrice = parseFloat(selectedProductDetails.price);
          const percentageOff = ((oldPrice - newPrice) / oldPrice * 100).toFixed(0);
          return `-${percentageOff}% de réduction`;
        }

        if (selectedProductDetails.oldPrice && selectedProductDetails.price) {
          const oldPrice = parseFloat(selectedProductDetails.oldPrice);
          const newPrice = parseFloat(selectedProductDetails.price);
          if (oldPrice > newPrice) {
            const percentageOff = ((oldPrice - newPrice) / oldPrice * 100).toFixed(0);
            return `-${percentageOff}% de réduction`;
          }
        }

        return "En réduction";
      })()}
    </div>
  )}

  {/* Price Display */}
  <h2
    className="price white-text"
    style={{
      margin: 0,
      fontSize: isMobile ? "1rem" : "1.25rem",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "flex-start" : "center",
      gap: "6px",
    }}
  >
    {selectedProductDetails?.promo ? (
      <>
        {selectedProductDetails.promo_type === "percentage" &&
        selectedProductDetails.promo_percentage ? (
          <>
            <span
              className="text-muted"
              style={{
                textDecoration: "line-through",
                opacity: 0.7,
                fontSize: isMobile ? "0.75rem" : "0.85rem",
                color: "#ffffff",
                marginRight: "8px",
              }}
            >
              {new Intl.NumberFormat("fr-FR", {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              }).format(parseFloat(selectedProductDetails.oldPrice))}{" "}
              DT
            </span>

            <span
              className="fw-bold"
              style={{
                color: "#fff9f2",
                fontSize: isMobile ? "1rem" : "1.2rem",
              }}
            >
              {new Intl.NumberFormat("fr-FR", {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              }).format(
                parseFloat(selectedProductDetails.oldPrice) *
                  (1 - selectedProductDetails.promo_percentage / 100)
              )}{" "}
              DT
            </span>
          </>
        ) : (
          <>
            <span
              className="text-muted"
              style={{
                textDecoration: "line-through",
                opacity: 0.7,
                fontSize: isMobile ? "0.75rem" : "0.85rem",
                color: "#ffffff",
                marginRight: "8px",
              }}
            >
              {selectedProductDetails.oldPrice &&
                new Intl.NumberFormat("fr-FR", {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                }).format(parseFloat(selectedProductDetails.oldPrice))}
            </span>

            <span
              className="fw-bold"
              style={{
                color: "#fff9f2",
                fontSize: isMobile ? "1rem" : "1.2rem",
              }}
            >
              {selectedProductDetails.price &&
                new Intl.NumberFormat("fr-FR", {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                }).format(parseFloat(selectedProductDetails.price))}{" "}
              DT
            </span>
          </>
        )}
      </>
    ) : (
      <span>
        {selectedProductDetails?.price
          ? new Intl.NumberFormat("fr-FR", {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3,
            }).format(parseFloat(selectedProductDetails.price))
          : "Prix non disponible"}{" "}
        DT
      </span>
    )}
  </h2>
</div>


  {/* Stock Availability */}
  <h5
    className="stock-status white-text"
    style={{
      margin: 0,
      fontSize: "0.85rem",
      opacity: 0.7,
      color: "#ffffff",
    }}
  >
    {selectedProductDetails?.available === false
      ? "❌ "
      : selectedProductDetails?.available === true
      ? "✔️ "
      : ""}
  </h5>
</div>

{product.description && (
  <div
    style={{
      backgroundColor: "#fff0f5", // light pink background
      color: "#333",
      padding: "1rem 1.25rem",
      borderRadius: "8px",
      fontStyle: "normal",
      lineHeight: "1.6",
      marginTop: "1rem",
      minHeight: "60px",
    }}
  >
    <p style={{ margin: 0 }}>
      {product.description}
    </p>
  </div>
)}


                                {/* Variations section - only show if product has variations */}
{hasVariations && product?.variations && (
  <>
    {/* Goût selection */}
    <div className="shop-details-dimension">
      <label htmlFor="goutSelect">Goût / Spécificité :</label>
      <select
        id="goutSelect"
        value={selectedGout || ""}
        onChange={(e) => {
          const newGout = e.target.value;
          setSelectedGout(newGout);

          // Safely pick first valid weight for this goût
          const firstPoids = (product.variations[newGout]?.weights?.[0] || "").trim();
          setSelectedPoids(firstPoids);
        }}
        style={{
          padding: "10px",
          marginTop: "10px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          width: "100%",
          maxWidth: "300px",
        }}
      >
        <option value="" disabled>
          Sélectionnez un goût
        </option>

        {Object.keys(product.variations).map((gout) => {
          // Only enable Goût if it has the currently selected Poids
          const hasSelectedPoids =
            !selectedPoids ||
            product.variations[gout]?.weights.some((w) => w.trim() === selectedPoids.trim());

          return (
            <option
              key={gout}
              value={gout}
              // Disabled if no matching poids
              style={{ backgroundColor: !hasSelectedPoids ? "#f7e3e3ff" : undefined }}
            >
              {gout} {!hasSelectedPoids ? "❌" : ""}
            </option>
          );
        })}
      </select>
    </div>

    {/* Poids selection */}
    {selectedGout && (
      <div className="shop-details-dimension" style={{ marginTop: "15px" }}>
        <label htmlFor="poidsSelect">Poids :</label>
        <select
          id="poidsSelect"
          value={selectedPoids || ""}
          onChange={(e) => setSelectedPoids(e.target.value)}
          style={{
            padding: "10px",
            marginTop: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            width: "100%",
            maxWidth: "300px",
          }}
        >
          <option value="" disabled>
            Sélectionnez un poids
          </option>

          {(product.variations[selectedGout]?.weights || []).map((poids) => {
            const valid =
              !!product.variations[selectedGout]?.details?.[poids];
            return (
              <option
                key={poids}
                value={poids}
                disabled={!valid}
                style={{ backgroundColor: !valid ? "#ffe6e6" : undefined }}
              >
                {poids} {!valid ? "❌" : ""}
              </option>
            );
          })}
        </select>

        {/* Availability display */}
     {selectedPoids && (
  <div style={{ marginTop: "20px", fontWeight: "bold" }}>
    {selectedProductDetails?.available ? (
      <span style={{ color: "green" }}>✔️ Disponible</span>
    ) : (
      <span style={{ color: "red" }}>❌ Indisponible</span>
    )}
  </div>
)}

      </div>
    )}
  </>
)}


                                <div className="shop-details-quantity">
                                    <span></span>
                                                                        <span></span>


                                    <div className="cart-plus-minus">
                                        <input type="text" value={val} readOnly />
                                        <div className="dec qtybutton" onClick={decrease}>-</div>
                                        <div className="inc qtybutton" onClick={increase}>+</div>
                                    </div>
<button
  onClick={handleAddToCart}
  disabled={
    product?.stock_status?.trim().toLowerCase() !== "en stock" ||
    (hasVariations &&
      (
        !selectedGout ||
        !selectedPoids ||
        !selectedProductDetails ||
        selectedProductDetails?.available === false
      ))
  }
  style={{
    backgroundColor: "#c71585",
    color: "#fff",
    height: "40px",
    padding: "6px 12px",
    borderRadius: "8px",
    fontSize: "13px",
    border: "none",
    cursor:
      product?.stock_status?.trim().toLowerCase() !== "en stock" ||
      (hasVariations &&
        (
          !selectedGout ||
          !selectedPoids ||
          !selectedProductDetails ||
          selectedProductDetails?.available === false
        ))
        ? "not-allowed"
        : "pointer",
    opacity:
      product?.stock_status?.trim().toLowerCase() !== "en stock" ||
      (hasVariations &&
        (
          !selectedGout ||
          !selectedPoids ||
          !selectedProductDetails ||
          selectedProductDetails?.available === false
        ))
        ? 0.5
        : 1,
    transition: "background 0.3s ease",
    marginBottom: "10px",
  }}
>
  {product?.stock_status?.trim().toLowerCase() !== "en stock" ||
  (hasVariations && selectedProductDetails?.available === false)
    ? "❌ Indisponible"
    : "Commander"}
</button>


                                </div>

                                {/* Pricing card */}
                                <div
                                    className="pricing-card"
                                    style={{
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                        padding: "16px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                        maxWidth: "5000px",
                                        backgroundColor: "#fff",
                                        marginTop: "16px",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: "20px",
                                    }}
                                >
                                 <div
  style={{
    background: "#f9fafb",
    padding: "16px",
    borderRadius: "12px",
    border: "1px solid #eee",
    width: "100%",
  }}
>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "10px",
      fontSize: "0.9rem",
      color: "#666",
    }}
  >
    <span>Prix unitaire</span>

    {selectedProductDetails?.promo &&
    selectedProductDetails?.promo_percentage ? (
      <span style={{ fontWeight: 600, color: "#16a34a", fontSize: "1rem" }}>
        {new Intl.NumberFormat("fr-FR", {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        }).format(
          parseFloat(selectedProductDetails.oldPrice) *
            (1 - selectedProductDetails.promo_percentage / 100)
        )}{" "}
        
      </span>
    ) : (
      <span style={{ fontWeight: 600, fontSize: "1rem", color: "#333" }}>
        {selectedProductDetails?.price || "Prix non disponible"}
      </span>
    )}
  </div>

  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "10px",
      fontSize: "0.9rem",
      color: "#666",
    }}
  >
    <span>Quantité</span>
    <span style={{ fontWeight: 600 }}>{val}</span>
  </div>

  <div
    style={{
      borderTop: "1px solid #e5e7eb",
      paddingTop: "12px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <span style={{ fontWeight: 600, fontSize: "1rem" }}>Total</span>

    <span
      style={{
        fontWeight: 700,
        fontSize: "1.2rem",
        color: "#111",
      }}
    >
      {(() => {
        const priceStr =
          selectedProductDetails?.promo &&
          selectedProductDetails?.promo_percentage
            ? (
                parseFloat(selectedProductDetails.oldPrice) *
                (1 - selectedProductDetails.promo_percentage / 100)
              ).toFixed(2)
            : selectedProductDetails?.price;

        if (!priceStr) return "⚠️ Prix manquant";

        const priceNum = parseFloat(priceStr);
        return !isNaN(priceNum)
          ? `${new Intl.NumberFormat("fr-FR", {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3,
            }).format(priceNum * val)} DT`
          : "⚠️ Erreur prix";
      })()}
    </span>
    
  </div>
</div>

                                </div>

                                {/* Product details */}
                                {/* {selectedProductDetails && (
                                    <div style={{ marginTop: "20px" }}>
                                        {selectedProductDetails.avantages && (
                                            <>
                                                <h3>Avantages :</h3>
                                                <p>{selectedProductDetails.avantages}</p>
                                            </>
                                        )}

                                        {selectedProductDetails.dose && (
                                            <>
                                                <h3>Dose quotidienne :</h3>
                                                <p>{selectedProductDetails.dose}</p>
                                            </>
                                        )}

                                        {selectedProductDetails.guide && (
                                            <>
                                                <h3>Ingrédients :</h3>
                                                <p>{selectedProductDetails.guide}</p>
                                            </>
                                        )}

                                        {selectedProductDetails.antioxidants && (
                                            <>
                                                <h3>Antioxydants :</h3>
                                                <p>{selectedProductDetails.antioxidants}</p>
                                            </>
                                        )}
                                    </div>
                                )} */}
                            </div>
                        </div>
                    </div>
                </div>

                <ProductTabs
                    selectedProduct={selectedProduct}
                    selectedGout={selectedGout}
                    selectedPoids={selectedPoids}
                />

{relatedProducts.length > 0 && (
  <div className="related-products-wrap mt-5">
    <h2 className="title">
      Produits Similaires
      {/* Optional: Show matching type */}
      <span style={{ fontSize: "0.8rem", color: "#888", marginLeft: "10px" }}>
        {relatedProductsType === "subcategory" && "(même sous-catégorie)"}
        {relatedProductsType === "category" && "(même catégorie)"}
      </span>
    </h2>

    <Slider className="row related-product-active" {...settingss}>
      {relatedProducts.map((related) => {
        // Parse subcategory and category for display
        let displaySubcategory = "";
        let displayCategory = "";

        try {
          const subs = typeof related.subcategory === 'string' 
            ? JSON.parse(related.subcategory) 
            : Array.isArray(related.subcategory) 
              ? related.subcategory 
              : [related.subcategory];
          displaySubcategory = Array.isArray(subs) ? subs.join(", ") : subs;
        } catch {
          displaySubcategory = related.subcategory || "";
        }

        try {
          const cats = typeof related.category === 'string' 
            ? JSON.parse(related.category) 
            : Array.isArray(related.category) 
              ? related.category 
              : [related.category];
          displayCategory = Array.isArray(cats) ? cats.join(", ") : cats;
        } catch {
          displayCategory = related.category || "";
        }

        return (
          <div className="col-lg" key={related.id}>
            <div
              className="shop-item mb-40"
              style={{ padding: "10px", fontSize: "0.9rem" }}
            >
              <div className="shop-thumb">
                <Link to={`/shop-details/${related.id}`}>
                  <img
                    src={related.image}
                    alt={related.name}
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "16px",
                      marginBottom: "0.75rem",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                  />
                </Link>
              </div>

              <div className="shop-content">
                <span>
                  {displaySubcategory || displayCategory || "Catégorie"}
                </span>

                <h4 className="title" style={{ fontSize: "1rem" }}>
                  <Link to={`/shop-details/${related.id}`}>
                    {related.name}
                  </Link>
                </h4>
{(() => {
  const price = related.price_range ?? related.priceRange;
  const priceNum = parseFloat(price);

  if (isNaN(priceNum)) return null; // cache tout le div si prix invalide

  // Ici tu peux définir "val", par exemple 1 si pas de multiplicateur
  const val = 1;

  return (
    <div
      style={{
        marginTop: "10px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <span
        style={{
          fontSize: "0.95rem",
          fontWeight: "700",
          color: "#ff41b4",
          background: "rgba(255, 65, 180, 0.08)",
          padding: "6px 12px",
          borderRadius: "12px",
        }}
      >
        { !isNaN(priceNum)
          ? `${new Intl.NumberFormat("fr-FR", {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3,
            }).format(priceNum * val)} DT`
          : "⚠️ Erreur prix" }
      </span>
    </div>
  );
})()}



              </div>
            </div>
          </div>
        );
      })}
    </Slider>
  </div>
)}

            </div>

{showModal && (
    <div
        style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
        }}
        onClick={() => setShowModal(false)}
    >
        <div
            style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "2rem",
                maxWidth: "500px",
                width: "90%",
                boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
                textAlign: "center",
                position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <div
                style={{
                    width: "60px",
                    height: "60px",
                    backgroundColor: "#28a745",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0 auto 1rem",
                    fontSize: "2rem",
                    color: "#fff",
                }}
            >
                ✓
            </div>

            <h2 style={{ marginBottom: "0.5rem", color: "#333" }}>
                Produit ajouté au panier!
            </h2>
            
            <p style={{ color: "#666", marginBottom: "2rem" }}>
                Votre article a été ajouté avec succès.
            </p>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    padding: "1rem",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    marginBottom: "1.5rem",
                }}
            >
                <img
                    src={selectedProductDetails?.image || product.image}
                    alt={product.name}
                    style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                                                                    marginLeft: isMobile ? "90px" : "0",
                        borderRadius: "8px",
                    }}
                />
                <div style={{ textAlign: "left", flex: 1 }}>
                    <h4 style={{ margin: 0, fontSize: "0.9rem", color: "#333" }}>
                        {product.name}
                    </h4>
                    <p style={{ margin: "0.25rem 0", fontSize: "0.85rem", color: "#666" }}>
                        Quantité: {val}
                    </p>
                    <p style={{ margin: "0.25rem 0 0 0", fontSize: "0.9rem", fontWeight: "600", color: "#c71585" }}>
                        {selectedProductDetails?.promo && selectedProductDetails?.promo_percentage ? (
                            <>
                                {new Intl.NumberFormat("fr-FR", { 
                                    minimumFractionDigits: 3, 
                                    maximumFractionDigits: 3 
                                }).format(
                                    parseFloat(selectedProductDetails.oldPrice) *
                                    (1 - selectedProductDetails.promo_percentage / 100) * val
                                )} DT
                            </>
                        ) : (
                            <>
                                {selectedProductDetails?.price
                                    ? new Intl.NumberFormat("fr-FR", { 
                                        minimumFractionDigits: 3, 
                                        maximumFractionDigits: 3 
                                    }).format(parseFloat(selectedProductDetails.price) * val)
                                    : "Prix non disponible"} DT
                            </>
                        )}
                    </p>
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    gap: "1rem",
                    flexDirection: "column",
                }}
            >
                <button
                    onClick={handleGoToCheckout}
                    style={{
                        backgroundColor: "#c71585",
                        color: "#fff",
                        padding: "0.75rem 1.5rem",
                        borderRadius: "8px",
                        border: "none",
                        fontSize: "1rem",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "background 0.3s ease",
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = "#a0135e"}
                    onMouseLeave={(e) => e.target.style.backgroundColor = "#c71585"}
                >
                    Commander
                </button>
                
                <button
                    onClick={handleContinueShopping}
                    style={{
                        backgroundColor: "transparent",
                        color: "#c71585",
                        padding: "0.75rem 1.5rem",
                        borderRadius: "8px",
                        border: "2px solid #c71585",
                        fontSize: "1rem",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#c71585";
                        e.target.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "#c71585";
                    }}
                >
                    Continuer vos achats
                </button>
            </div>
        </div>
    </div>
)}
        </section>
    );
}
